var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIssue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 7.62939e-06C1.69891 7.62939e-06 1.88968 0.0790254 2.03033 0.219678C2.17098 0.36033 2.25 0.551095 2.25 0.750007V5.25001C2.25 5.44892 2.17098 5.63968 2.03033 5.78034C1.88968 5.92099 1.69891 6.00001 1.5 6.00001C1.30109 6.00001 1.11032 5.92099 0.96967 5.78034C0.829018 5.63968 0.75 5.44892 0.75 5.25001V0.750007C0.75 0.551095 0.829018 0.36033 0.96967 0.219678C1.11032 0.0790254 1.30109 7.62939e-06 1.5 7.62939e-06V7.62939e-06Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 7.50001C1.30109 7.50001 1.11032 7.57902 0.96967 7.71968C0.829018 7.86033 0.75 8.05109 0.75 8.25001C0.75 8.44892 0.829018 8.63969 0.96967 8.78034C1.11032 8.92099 1.30109 9.00001 1.5 9.00001C1.69891 9.00001 1.88968 8.92099 2.03033 8.78034C2.17098 8.63969 2.25 8.44892 2.25 8.25001C2.25 8.05109 2.17098 7.86033 2.03033 7.71968C1.88968 7.57902 1.69891 7.50001 1.5 7.50001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssue);
export default __webpack_public_path__ + "static/media/issue.a1ba3418ee40d326e8c0afebb0d7ab42.svg";
export { ForwardRef as ReactComponent };